import { Platform } from "react-native";

export default class AppConstants {

  static VERSION_ID = '1.0.1r17';

  static deepBlue = '#3251B1';

  static seekingColor = '#3251B1'; // used to be #450DA5';
  static arrivedColor = '#F56700'; // used to be '#F1B13E';

  static skipDelay    = false;  // FALSE   - no delay on contentitems showing up. Should be false for real show
  static checkinInterval    = 30000;  // 30000   - for how frequently the GPS checks in
  static preludeCoverColor = '#666';
  static overtureCoverColor = '#666';
  static blueColor = '#50A9DA';
}

export const assetReference = originalAssetName => {
  //console.log("Building reference for " + originalAssetName);
  // android asset filenames are very picky so we need to rename things from the CMS so it can find them.
  let result = '' + originalAssetName;
  if (Platform.OS === 'android' && !originalAssetName.match(/^http/)) {
    //console.log(" *** Starting asset name: " + result);
    // filenames have to be all lowercase
    result = result.toLowerCase(); 
    // can't have "-" but instead "_"
    result = result.replace(/-/g, "_");
    // can't start with a number, so we we add "a" to the front
    if (result.match(/^\d/)) {
      result = "a" + result;
    }

    // filenames can't match, even if with different prefixes (e.g. tw.mp3 vs tw.png) so we add "audio-" to the front of mp3 and m4a files
    // this isn't strictly needed anymore but we've already renamed the files
    if (result.match(/.mp3$/) || result.match(/.m4a$/)) {
      result = "audio_" + result;
    }

    const localExceptions = ['audio_sj_02.mp3', 'db.mp4', 'audio_introuke.mp3'];
    if (!(localExceptions.indexOf(result) > -1)) {
      // if it's an audio or video file and not one of our special ones, use streaming: 
      if (result.match(/.mp3$/) || result.match(/.mp4$/) || result.match(/.m4a$/)) {
        result = 'https://com-nowhereapp.s3.amazonaws.com/media/' + result;
      }
    } else {
      result = result.replace(".mp4", "");
      result = result.replace(".mp3", "");
    }

    // android doesn't like filetype suffixes either 
    result = result.replace(".jpg", "");
    result = result.replace(".png", "");  
    
    //console.log("   *** Final asset name: " + result);
  }
  return result;
}

export const imageSizes = (contextWidth, sourceItem) => {
  let imageWidth = sourceItem.width;   // e.g. 400
  let imageHeight = sourceItem.height; // e.g. 300
  
  let heightRatio = 1.0;  

  if (!!(imageHeight)) {
    heightRatio = imageHeight / imageWidth;  // e.g 1.333
  }

  imageWidth = contextWidth;               // e.g. 300
  imageHeight = imageWidth * heightRatio; // e.g. 400 

  return {width: imageWidth, height: imageHeight}
}

export const doesItemHaveTag = (item, tag) => {
  let result = false;
  if (!!(item.selected_tags_list)) {
    for (let i=0; i<item.selected_tags_list.length && result === false; i++) {
      if (item.selected_tags_list[i] === tag) {
        result = true;
      }
    }
  }
  return result;
}
